<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="sending">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Sending, please wait
        </div>
      </div>
    </div>
    <div class="box-content">
      <div class="flex-2xs justify-end pb-3">
          <div class="pr-3-2xs" v-if="!staff_user">
            <a class="btn-primary" @click.prevent="enquiry_box_open = true">
              New&nbsp;Enquiry
            </a>
          </div>
        <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open" style="min-width:165px; max-width: 400px;">
          <div class="multi-select-input-placeholder">
            Filter...
            <div class="dropdown-icon">
              <i class="fal fa-chevron-down"></i>
            </div>
          </div>
          <div class="multi-select-input-inner" v-show="filter_dropdown_open">
            <div class="multi-select-input-group">
              <h1 class="input-group-title">Date</h1>
              <div class="checkboxes">
                <div class="checkbox level-1">
                  <label>
                    <input type="radio" name="date_filter_type" :value="'updated_at'" v-model="date_filter_type">
                    <span class="checkbox-label">Last Updated</span>
                  </label>
                </div>
                <div class="checkbox level-1">
                  <label>
                    <input type="radio" name="date_filter_type" :value="'created_at'" v-model="date_filter_type">
                    <span class="checkbox-label">Date Created</span>
                  </label>
                </div>
                <div class="mt-2" @click.stop>
                  <div class="input-group">
                    <div class="input-group-addon" style="width: 60px;">From:</div>
                    <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
                  </div>
                  <div class="input-group mt-1">
                    <div class="input-group-addon" style="width: 60px;">To:</div>
                    <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="multi-select-input-group mt-3">
              <h1 class="input-group-title">Status</h1>
              <div class="checkboxes">
                <div class="checkbox level-1" v-for="status in enquiry_statuses">
                  <label>
                    <input type="checkbox" name="status" :value="status.id" v-model="status_filter">
                    <span class="checkbox-label">{{ status.label }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="multi-select-input-group mt-3" v-if="staff_user">
              <h1 class="input-group-title">Enquiry Types</h1>
              <div class="checkboxes">
                <div class="checkbox level-1" v-for="enquiry_type in enquiry_types">
                  <label>
                    <input type="checkbox" name="status" :value="enquiry_type.id" v-model="enquiry_type_filter">
                    <span class="checkbox-label">{{ enquiry_type.label }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

<!--          <div class="flex-2xs pr-3">-->
<!--            <div class="pr-3-2xs pb-2 pb-0-2xs">-->
<!--              <select class="form-control" v-model="date_filter_type">-->
<!--                <option value="created_at">-->
<!--                  Date created-->
<!--                </option>-->
<!--                <option value="updated_at">-->
<!--                  Last Updated-->
<!--                </option>-->
<!--              </select>-->
<!--            </div>-->
<!--            <div class="pr-3-2xs pb-2 pb-0-2xs">-->
<!--              <div class="input-group">-->
<!--                <div class="input-group-addon">From:</div>-->
<!--                <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="pr-3-2xs pb-2 pb-0-2xs">-->
<!--              <div class="input-group">-->
<!--                <div class="input-group-addon">To:</div>-->
<!--                <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div :class="{ 'pr-3' : staff_user }">-->
<!--            <select class="form-control" v-model="status_filter">-->
<!--              <option value="" v-if="status_filter === ''">Status ...</option>-->
<!--              <option value="" v-else> Clear Filter</option>-->
<!--              <option v-for="status in enquiry_statuses" :value="status.id">-->
<!--                {{ status.label }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->
          <div v-if="staff_user" class="ml-3-2xs mt-3 mt-0-2xs">
            <input type="text" placeholder="Search Company" class="form-control" v-model="search_query" style="min-width: 200px;">
          </div>
      </div>
      <template v-if="!loading && total_count > 0">
        <table class="table_enquiries-list">
          <thead>
          <tr>
            <th>Last Updated</th>
            <th>Type</th>
            <th v-show="staff_user">From</th>
            <th v-show="staff_user">Assigned to</th>
            <th>Status</th>
            <th>Unread</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(enquiry, index) in enquiries" :class="{ 'shaded-positive' : enquiry.unread_messages_count > 0 }">
            <td>{{ enquiry.friendly_last_updated }}</td>
            <td>{{ enquiry.enquiry_type.label }}</td>
            <td v-show="staff_user">{{ enquiry.from_user.company.name }} ({{ enquiry.from_user.company.company_type.label }})</td>
            <td v-show="staff_user">
              <template v-if="enquiry.assigned_to_user">
                {{ enquiry.assigned_to_user.name }}
              </template>
              <template v-else>
                --
              </template>
            </td>
            <td>{{ enquiry.enquiry_status.label }}</td>
            <td class="td_unread-messages">
              <div class="txt-primary">
                <i class="fal fa-envelope"></i> {{ enquiry.unread_messages_count }}
              </div>
            </td>
            <td class="td_view-enquiry">
              <a :href='"/enquiry/"+enquiry.id' class="txt-primary">
                <i class="fa fa-eye"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
        <template>
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="!loading && total_count === 0">
        <strong>
          No Results Found
        </strong>
      </template>
    </div>
    <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
      <div class="modal-window-inner" @click.stop>
        <div class="modal-close" @click.stop="enquiry_box_open = false">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-header">
          <h1 class="modal-title">General Enquiry</h1>
        </div>
        <div class="modal-content">
          <div class="form-group">
            Please enter details of your enquiry below.
          </div>
          <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
        </div>
        <div class="modal-footer align-right">
          <a class="btn-primary" @click="sendEnquiry()">
            Send
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  mounted() {
    this.loadEnquiries();
  },
  props: [
    'staff_user',
    'enquiry_types',
    'enquiry_statuses',
  ],
  components: {
    'datepicker': Datepicker,
  },
  data() {
    return {
      enquiries: [],
      search_query: '',
      current_page: 1,
      enquiry_type_filter: [],
      status_filter: [],
      total_count: 0,
      total_pages: 0,
      enquiry_box_open: false,
      enquiry_message: '',
      limit: 20,
      loading: true,
      sending: false,
      date_filter_type: 'updated_at',
      date_filter_start: null,
      date_filter_end: new Date(),
      filter_dropdown_open: false,
    }
  },
  methods: {
    loadEnquiries: _.debounce(function () {
      axios.post('/enquiry/loadEnquiries', {
        page_number: this.current_page,
        enquiry_type_filter: this.enquiry_type_filter,
        status_filter: this.status_filter,
        search_query: this.search_query,
        date_filter_type: this.date_filter_type,
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        limit: this.limit,
      }).then((response) => {
        this.enquiries = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
      });
    }, 250),
    sendEnquiry() {
      if (this.enquiry_message === '') {
        swal('Please enter a message');
        return;
      }
      this.enquiry_box_open = false;
      this.sending = true;
      axios.post('/enquiry/send', {
        'enquiry_type_id': 22,
        'message': this.enquiry_message,
      }).then((response) => {
        this.enquiry_message = '';
        this.loadEnquiries();

        gtag('event', 'enquiry_made', {
          'event_category': 'enquiries',
          'event_label': 'General enquiry',
          'value': 'General enquiry',
        });

        this.sending = false;
        Swal.fire({
          title: 'Enquiry Sent',
          icon: 'success',
          text: 'Your enquiry has been submitted, you will be sent a notification when you receive a reply.'
        });
      });
    },
    prevPage() {
      this.current_page = this.current_page - 1;
      this.loadEnquiries();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.loadEnquiries();
    }
  },
  watch: {
    enquiry_type_filter() {
      this.current_page = 1;
      this.loadEnquiries();
    },
    status_filter() {
      this.current_page = 1;
      this.loadEnquiries();
    },
    search_query() {
      this.current_page = 1;
      this.loadEnquiries();
    },
    date_filter_type() {
      this.current_page = 1;
      this.loadEnquiries();
    },
    date_filter_start() {
      this.current_page = 1;
      this.loadEnquiries();
    },
    date_filter_end() {
      this.current_page = 1;
      this.loadEnquiries();
    },
  },
};
</script>
